/** German strings for the in-race game layer (race director, cockpit, coach). Keys are the exact English source text. */
export const DE_GAME: Readonly<Record<string, string>> = {
  // Race director: launch
  'SETTLE THE SCORE.': 'ZEIT FÜR REVANCHE.',
  'HUNT THE MARKED CAR.': 'JAG DAS MARKIERTE AUTO.',
  'ONE LAP. NO ALIBIS.': 'EINE RUNDE. KEINE AUSREDEN.',
  'MAKE IT COUNT.': 'JETZT ZÄHLT’S.',
  'TARGET // {name}': 'ZIEL // {name}',
  'TAKEDOWNS SCORE · REPAIR GATES KEEP YOU ALIVE': 'TAKEDOWNS PUNKTEN · REPARATURTORE HALTEN DICH IM RENNEN',
  'LAST PLACE GETS CUT': 'DER LETZTE FLIEGT RAUS',
  'RACE CONTROL // GREEN': 'RENNLEITUNG // GRÜN',

  // Race director: dynamic track events
  'ROAD HAZARD AHEAD.': 'GEFAHR VORAUS.',
  'LANE CLOSED.': 'SPUR GESPERRT.',
  'ROAD CLEARING.': 'STRECKE WIRD FREI.',
  '{event} // KEEP LEFT': '{event} // LINKS HALTEN',
  '{event} // KEEP RIGHT': '{event} // RECHTS HALTEN',
  'LANE CLOSURE': 'SPURSPERRUNG',
  'STREET CROSSING': 'QUERVERKEHR',
  'ROADBLOCK': 'STRASSENSPERRE',

  // Race director: boss phases and moves
  'FINAL ACT.': 'FINALE.',
  'THE BOSS HAS NOTHING LEFT TO HIDE': 'DER BOSS ZEIGT JETZT ALLES',
  'THE BOSS IS HUNTING.': 'DER BOSS JAGT DICH.',
  'EXPECT A FAST RESPONSE': 'ER SCHLÄGT SCHNELL ZURÜCK',
  'PRESSURE PHASE.': 'DRUCKPHASE.',
  'BREAK THE DEFENSIVE LINE': 'KNACK SEINE VERTEIDIGUNG',
  'RIVAL BOSS ON GRID.': 'BOSS IN DER STARTAUFSTELLUNG.',
  'WATCH THE SIGNATURE MOVE': 'ACHTUNG, SPEZIALMANÖVER',
  '{name} MAKES A MOVE.': '{name} GREIFT AN.',
  'SIGNATURE DRIFT // HOLD YOUR LINE': 'SPEZIAL-DRIFT // HALT DEINE LINIE',
  'TRICK ROUTE // DO NOT FOLLOW BLIND': 'TRICKROUTE // NICHT BLIND FOLGEN',
  'CONTACT ATTACK // BRACE': 'RAMMANGRIFF // FESTHALTEN',
  'DEFENSIVE MOVE // FIND ANOTHER LINE': 'BLOCKADE // SUCH DIR EINE ANDERE LINIE',

  // Race director: road rage and pursuit
  'MARKED // {name}': 'MARKIERT // {name}',
  'TAKEDOWN BONUS · REPAIR + NITRO PAYOUT': 'TAKEDOWN-BONUS · REPARATUR + NITRO',
  'INTERCEPTOR PACK DEPLOYED.': 'ABFANGJÄGER IM EINSATZ.',
  'PURSUIT ENGAGED.': 'VERFOLGUNG LÄUFT.',
  'HEAT {heat} // {n} UNIT ACTIVE': 'FAHNDUNG {heat} // {n} EINHEIT AKTIV',
  'HEAT {heat} // {n} UNITS ACTIVE': 'FAHNDUNG {heat} // {n} EINHEITEN AKTIV',

  // Race director: live contracts
  'CONTRACT CLEARED.': 'AUFTRAG ERFÜLLT.',
  'CONTRACT MISSED.': 'AUFTRAG VERPASST.',
  'LIVE CONTRACT': 'LIVE-AUFTRAG',
  'OPTIONAL OBJECTIVE': 'OPTIONALES ZIEL',
  '+STYLE // +NITRO': '+STYLE // +NITRO',
  'NEXT OFFER INCOMING': 'NÄCHSTES ANGEBOT KOMMT',

  // Race director: sectors, signatures, laps, passes
  'SECTOR WON.': 'SEKTOR GEWONNEN.',
  'SECTOR LOST.': 'SEKTOR VERLOREN.',
  '{delta} // RIVAL DELTA': '{delta} // ABSTAND ZUM RIVALEN',
  '+{n} NITRO': '+{n} NITRO',
  'ATTACK BOOST': 'ANGRIFFS-BOOST',
  '+{n} INTEGRITY': '+{n} INTEGRITÄT',
  '{name} ACTIVATED.': '{name} AKTIVIERT.',
  'FINAL PUSH.': 'ENDSPURT.',
  'FINAL LAP.': 'LETZTE RUNDE.',
  'PROTECT THE LEAD': 'VERTEIDIGE DIE FÜHRUNG',
  'EVERY PASS COUNTS': 'JEDES ÜBERHOLMANÖVER ZÄHLT',
  'RIVAL TAKEN.': 'RIVALE GESCHNAPPT.',
  'PASS CONFIRMED.': 'ÜBERHOLT.',
  '{name} // NOW BEHIND': '{name} // JETZT HINTER DIR',
  '{place} PLACE': '{place} PLATZ',

  // Race director: alternate routes
  '{purpose} {kind} · {risk} · {surface} // +{payout} NITRO': '{kind}: {purpose} · {risk} · {surface} // +{payout} NITRO',
  'TIME CUT': 'ZEITGEWINN',
  'STYLE JACKPOT': 'STYLE-JACKPOT',
  'SHORTCUT': 'ABKÜRZUNG',
  'LOOP': 'SCHLEIFE',
  'SAFE': 'SICHER',
  'TECHNICAL': 'TECHNISCH',
  'EXTREME': 'EXTREM',
  'ASPHALT': 'ASPHALT',
  'SERVICE': 'SERVICEWEG',
  'GRAVEL': 'SCHOTTER',

  // Race director: pressure and finish
  'DANGER ZONE.': 'GEFAHRENZONE.',
  'MAKE THE PASS OR YOU ARE OUT': 'ÜBERHOL ODER DU BIST RAUS',
  'NO SECOND LAP.': 'KEINE ZWEITE RUNDE.',
  'EMPTY THE NITRO': 'HAU DAS NITRO RAUS',
  'RIVAL IN RANGE.': 'RIVALE IN REICHWEITE.',
  'PRESSURE BEHIND.': 'DRUCK VON HINTEN.',
  '{name} // HOLD YOUR LINE': '{name} // HALT DEINE LINIE',
  'DISTRICT OWNED.': 'BEZIRK GEHÖRT DIR.',
  'PODIUM LOCKED.': 'PODIUM GESICHERT.',
  'RUN BANKED.': 'LAUF IM KASTEN.',
  'RACE CONTROL // WIN CONFIRMED': 'RENNLEITUNG // SIEG BESTÄTIGT',
  '{place} PLACE // STYLE {score}': '{place} PLATZ // STYLE {score}',

  // Corner coach
  'BRAKE': 'BREMSEN',
  'LIFT': 'GAS WEG',
  'TIGHT CORNER': 'ENGE KURVE',
  'CORNER AHEAD': 'KURVE VORAUS',

  // Sound toggle
  'SOUND OFF': 'TON AUS',
  'SOUND ON': 'TON AN',

  // Graphics summary
  'WORLD UPDATE AFTER RACE': 'WELT-UPDATE NACH DEM RENNEN',
  'AUTO {fps} FPS': 'AUTO {fps} FPS',
  'LOW': 'NIEDRIG',
  'MEDIUM': 'MITTEL',
  'HIGH': 'HOCH',
  'ULTRA': 'ULTRA',
  'ADAPTIVE': 'ADAPTIV',
  'FIXED': 'FEST',
  'LOCAL SHADOWS': 'LOKALE SCHATTEN',
  'NO SHADOWS': 'KEINE SCHATTEN',
  'DIRECT RENDER': 'DIREKTES RENDERING',
  'SCALED BLOOM': 'SKALIERTER BLOOM',
  'NO BLOOM': 'KEIN BLOOM',

  // Cockpit instruments (canvas)
  'GEAR': 'GANG',
  'POS': 'POS',
  'NITRO': 'NITRO',
  'INTEGRITY': 'INTEGRITÄT',
  'SHIFT': 'SCHALTEN',
  'G-FORCE': 'G-KRAFT',
  'LAP': 'RUNDE',
};
